import React from 'react'
import { Routes as AppRoutes, Route, Navigate } from 'react-router-dom'

import AppPermissionsScreen from './appPermissions/AppPermissionsScreen'
import ClientSearchScreen from './clientSearch/ClientSearchScreen/ClientSearchScreen'
import CommercialRulesFormScreen from './commercialRules/CommercialRulesFormScreen/CommercialRulesFormScreen'
import CommercialRulesScreen from './commercialRules/CommercialRulesScreen'
import PrivateRoute from './commons/components/PrivateRouteComponent'
import { ROUTES } from './commons/utils/AppRoutes'
import { UserContextProvider, useUserContext } from './context/UserContext'
import FeatureFlagsScreen from './featureFlags/FeatureFlagsScreen'
import HomeScreen from './home/HomeScreen'
import ImportScreen from './import/ImportScreen'
import Login from './login/Login'
import MillManagementFormScreen from './millManegement/MillManagementFormScreen'
import MillManagementListScreen from './millManegement/MillManagementListScreen'
import { Auth, UserGroups } from './models/Auth'
import NotificationScreen from './news/NotificationScreen'
import UserSearchScreen from './userSearch/UserSearchScreen/UserSearchScreen'

const Routes: React.FC = () => {
    const authentication = new Auth()
    const { loadUser } = useUserContext()

    React.useEffect(() => {
        const fetchUser = async () => {
            await loadUser()
        }
        fetchUser()
    }, [loadUser])

    return (
        <UserContextProvider>
            <AppRoutes>
                <Route path={ROUTES.LOGIN} element={<Login />} />
                <Route
                    path={ROUTES.HOME}
                    element={
                        <PrivateRoute
                            visibleTo={[UserGroups.Seller, UserGroups.STC]}
                            auth={authentication}
                            redirectPath={ROUTES.LOGIN}
                            component={<HomeScreen />}
                        />
                    }
                />
                <Route
                    path={ROUTES.NEWS}
                    element={
                        <PrivateRoute
                            visibleTo={[
                                UserGroups.MillsAdmin,
                                UserGroups.DsmAdmin,
                            ]}
                            auth={authentication}
                            redirectPath={ROUTES.HOME}
                            component={<NotificationScreen />}
                        />
                    }
                />
                <Route
                    path={ROUTES.IMPORT}
                    element={
                        <PrivateRoute
                            visibleTo={[UserGroups.MillsAdmin]}
                            auth={authentication}
                            redirectPath={ROUTES.HOME}
                            component={<ImportScreen />}
                        />
                    }
                />
                <Route
                    path={ROUTES.MILLSLIST}
                    element={
                        <PrivateRoute
                            visibleTo={[
                                UserGroups.MillsAdmin,
                                UserGroups.FinancialSupport,
                            ]}
                            auth={authentication}
                            redirectPath={ROUTES.HOME}
                            component={<MillManagementListScreen />}
                        />
                    }
                />
                <Route
                    path={ROUTES.MILLSNEW}
                    element={
                        <PrivateRoute
                            visibleTo={[UserGroups.MillsAdmin]}
                            auth={authentication}
                            redirectPath={ROUTES.HOME}
                            component={<MillManagementFormScreen />}
                        />
                    }
                />

                <Route
                    path={ROUTES.MILLEDIT}
                    element={
                        <PrivateRoute
                            visibleTo={[
                                UserGroups.MillsAdmin,
                                UserGroups.FinancialSupport,
                            ]}
                            auth={authentication}
                            redirectPath={ROUTES.HOME}
                            component={<MillManagementFormScreen />}
                        />
                    }
                />
                <Route
                    path={ROUTES.APPPERMISSIONS}
                    element={
                        <PrivateRoute
                            visibleTo={[UserGroups.DsmAdmin]}
                            auth={authentication}
                            redirectPath={ROUTES.HOME}
                            component={<AppPermissionsScreen />}
                        />
                    }
                />
                <Route
                    path={ROUTES.COMMERCIALRULES}
                    element={
                        <PrivateRoute
                            visibleTo={[UserGroups.DsmAdmin]}
                            auth={authentication}
                            redirectPath={ROUTES.HOME}
                            component={<CommercialRulesScreen />}
                        />
                    }
                />
                <Route
                    path={ROUTES.COMMERCIALRULESNEW}
                    element={
                        <PrivateRoute
                            visibleTo={[UserGroups.DsmAdmin]}
                            auth={authentication}
                            redirectPath={ROUTES.HOME}
                            component={<CommercialRulesFormScreen />}
                        />
                    }
                />
                <Route
                    path={ROUTES.COMMERCIALRULESEDIT}
                    element={
                        <PrivateRoute
                            visibleTo={[UserGroups.DsmAdmin]}
                            auth={authentication}
                            redirectPath={ROUTES.HOME}
                            component={<CommercialRulesFormScreen />}
                        />
                    }
                />
                <Route
                    path={ROUTES.USERSEARCH}
                    element={
                        <PrivateRoute
                            visibleTo={[UserGroups.DsmAdmin]}
                            auth={authentication}
                            redirectPath={ROUTES.HOME}
                            component={<UserSearchScreen />}
                        />
                    }
                />
                <Route
                    path={ROUTES.CLIENTSEARCH}
                    element={
                        <PrivateRoute
                            visibleTo={[UserGroups.DsmAdmin]}
                            auth={authentication}
                            redirectPath={ROUTES.HOME}
                            component={<ClientSearchScreen />}
                        />
                    }
                />
                <Route
                    path={ROUTES.FEATUREFLAGS}
                    element={
                        <PrivateRoute
                            visibleTo={[UserGroups.DsmAdmin]}
                            auth={authentication}
                            redirectPath={ROUTES.HOME}
                            component={<FeatureFlagsScreen />}
                        />
                    }
                />
                <Route path="*" element={<Navigate to={ROUTES.LOGIN} />} />
            </AppRoutes>
        </UserContextProvider>
    )
}

export default Routes
